export type SkuComponentType = 'gift' | 'set_item';

export interface SkuComponentLike {
  id: string;
  title: string;
  quantity: number;
  comment?: string;
  componentType?: SkuComponentType;
}

export function normalizeSkuComponentType(value?: string): SkuComponentType {
  return value === 'set_item' ? 'set_item' : 'gift';
}

export function groupSkuComponents<T extends SkuComponentLike>(components: T[] = []) {
  return {
    setItems: components.filter((component) => normalizeSkuComponentType(component.componentType) === 'set_item'),
    gifts: components.filter((component) => normalizeSkuComponentType(component.componentType) === 'gift'),
  };
}

export function formatSetCompositionSummary(components: SkuComponentLike[] = []): string | null {
  const { setItems } = groupSkuComponents(components);
  if (setItems.length === 0) return null;

  return setItems
    .map((component) => {
      const title = component.title.trim();
      if (!title) return null;
      return component.quantity > 1 ? `${title} x${component.quantity}` : title;
    })
    .filter((title): title is string => Boolean(title))
    .join(', ') || null;
}

export function formatCatalogSetCompositionSummary(
  categoryName: string | undefined,
  components: SkuComponentLike[] = []
): string | null {
  if (categoryName?.trim() !== 'Наборы') return null;
  return formatSetCompositionSummary(components);
}
